// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#atlwdg-trigger {\n  background: var(--brand--le--primary-color--base);\n  color: #fff !important;\n  border: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  border-radius: 4px 0 0 0;\n  text-transform: uppercase;\n  font-family: \"Open Sans\", sans-serif;\n  font-weight: 600;\n  font-size: 11px;\n  padding: 6px 12px;\n}\n", ""]);
// Exports
module.exports = exports;
